import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { skipButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://www.skipthedishes.com/jumak-korean-kitchen?version=v2`}
              target="_blank"
            >
              <CFView hover>
                <CFImage src={skipButton} maxWidth="230px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://www.skipthedishes.com/jumak-korean-kitchen?version=v2`}
              target="_blank"
            >
              <CFView hover>
                <CFImage src={skipButton} maxWidth="260px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
